module.exports = __webpack_public_path__ + "assets/img/img-advice-error.622ef68e.svg";